import React from 'react';
import TopSmoke from './TopSmoke';
import { SMOKE_DAY } from '../../../../../../content';

const TopSmokeContainer = props => {
  const { posX } = props;

  // turn on mine smokes
  const active = posX < SMOKE_DAY.MAX;
  const styleSmoke = {
    visibility: active ? 'visible' : 'hidden',
    opacity: Math.max(
      Math.min((SMOKE_DAY.MAX - posX) / (SMOKE_DAY.MAX - SMOKE_DAY.MIN), 1),
      0
    ),
  };

  return <TopSmoke active={active} styleSmoke={styleSmoke} />;
};

export default TopSmokeContainer;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneTop/TopSmoke/TopSmokeContainer.js